import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appQueriesStore } from "@/app/api";
import { errorToast } from "@/shared/ui";
import { consultationsQueriesStore, rescheduleAppointment } from "../api";

export const useRescheduleAppointment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: rescheduleAppointment,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: consultationsQueriesStore.consultations.appointments.queryKey,
      });
      void queryClient.invalidateQueries({
        queryKey: appQueriesStore.user.queryKey,
      });
    },
    onError: errorToast,
  });
};
